<template>
  <!-- Main Sidebar -->
  <a-layout-sider collapsible class="sider-primary" breakpoint="lg" collapsed-width="0" width="250px"
    :collapsed="sidebarCollapsed" @collapse="$emit('toggleSidebar', !sidebarCollapsed)" :trigger="null" :class="[
      'ant-layout-sider-' + sidebarColor,
      'ant-layout-sider-' + sidebarTheme,
    ]" theme="light" :style="{ backgroundColor: 'transparent' }">
    <div class="brand">
      <img src="images/logo-ct-black.png" alt />
      <span>GHS</span>
    </div>
    <hr />

    <!-- Sidebar Navigation Menu -->
    <a-menu theme="light" mode="inline" :open-keys="openKeys" @openChange="onOpenChange">
      <a-menu-item>
        <router-link to="/dashboards/">
          <span class="icon">
            <a-icon type="dashboard" theme="filled" class="m-0" />
          </span>
          <span class="label">Dashboard</span>
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="isAdmin()">
        <router-link to="/Customers/Customer-list">
          <span class="icon">
            <a-icon type="customer-service" theme="filled" class="m-0" />
          </span>
          <span class="label">Customers</span>
        </router-link>
      </a-menu-item>
      <!-- <a-menu-item v-if="isAdmin()">
        <router-link to="/Customers/Customer-list">
          <span>
            <a-icon type="customer-service" theme="filled" class="m-0" />
          </span>
          <span class="label">Customers</span>
        </router-link>
      </a-menu-item> -->
      <a-sub-menu v-if="isAdmin()" key="applications" style="padding: 0">
        <span slot="title">
          <span class="icon">
            <a-icon type="appstore" theme="filled" class="m-0" />
          </span>
          <span class="label">Core Data</span>
        </span>
        <a-menu-item-group>
          <a-menu-item>
            <router-link to="/classifications/classifications-list">
              <span class="label">Classifications</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/classificationgroups/classificationgroups-list">
              <span class="label">Classification Groups</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/acutetox/acutetox-list">
              <span class="label">Acute Toxicity </span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/pointestimate/pointestimate-list">
              <span class="label">Converted Point estimate</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/oecdguidelines/oecdguidelines-list">
              <span class="label">OECD Guidelines</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/hazardcategory/hazardcategory-list">
              <span class="label">Hazard Categories</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/ecoinfo/ecoinfo-list">
              <span class="label">Ecological Information</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/phrasedisposal/phrasedisposal-list">
              <span class="label">Phrase Disposal</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/phraseprevention/phraseprevention-list">
              <span class="label">Phrase Prevention</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/phraseresponse/phraseresponse-list">
              <span class="label">Phrase Response</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/phrasestorage/phrasestorage-list">
              <span class="label">Phrase Storage</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/pictogramimages/pictogramimages-list">
              <span class="label">Pictogram Images</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/elements/elements-list">
              <span class="label">Elements</span>
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/RestrictedBlends/RestrictedBlends-list">
              <span class="label">Restricted Blends</span>
            </router-link>
          </a-menu-item>

        </a-menu-item-group>
      </a-sub-menu>
      <a-menu-item>
        <router-link to="/Recipe/Recipe-list">
          <span class="icon">
            <a-icon type="dashboard" theme="filled" class="m-0" />
          </span>
          <span class="label">Recipes</span>
        </router-link>
      </a-menu-item>
      <!-- <a-menu-item>
        <router-link to="/test/">
          <span class="icon">
            <a-icon type="dashboard" theme="filled" class="m-0" />
          </span>
          <span class="label">Recipe Templates</span>
        </router-link>
      </a-menu-item> -->
    </a-menu>

    <!-- / Sidebar Navigation Menu -->

    <!-- Sidebar Footer -->
    <div class="aside-footer">
    </div>
    <!-- / Sidebar Footer -->
  </a-layout-sider>
  <!-- / Main Sidebar -->
</template>

<script>
export default {
  props: {
    // Sidebar collapsed status.
    sidebarCollapsed: {
      type: Boolean,
      default: false,
    },

    // Main sidebar color.
    sidebarColor: {
      type: String,
      default: "primary",
    },

    // Main sidebar theme : light, white, dark.
    sidebarTheme: {
      type: String,
      default: "light",
    },
  },
  data() {
    return {
      rootSubmenuKeys: [
        "dashboards",
        "pages",
        "applications",
        "ecommerce",
        "authentication",
        "basic",
        "components",
        "changelog",
      ],
      openKeys: this.$route.meta.sidebarMap,
    };
  },
  methods: {
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );

      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    isAdmin() {
      return this.admin;
    } 
  },
  computed: {
    user: {
      get() {
        return this.$store.state.user.user;
      }
    },
    admin: {
      get() {
        return this.$store.getters['user/isAdmin'];
      }
    },
  },
};
</script>
